//********* TUTORIALS *********//
import * as types from "./actionTypes";

export const toggleShowAdvancedQuoting = (showAdvancedQuoting) => ({
  type: types.TOGGLE_SHOW_ADVANCED_QUOTING,
  payload: {showAdvancedQuoting}
});

export const setAdvancedQuotingSearchItem = (advancedQuotingSearchItem) => ({
  type: types.SET_ADVANCED_QUOTING_SEARCH_ITEM,
  payload: {advancedQuotingSearchItem}
});
